module.exports = __webpack_public_path__ + "img/to-top.4baee7ee.svg";